module.exports = __webpack_public_path__ + "img/1.6c2c7098.png";